export default {
	data() {
		return {
			chooseCount: 0,
			//选修按钮索引
			allChecked: false,
			// 所有商品的数组
			order: [],
			// 总价
			totalprices: 0,
			// ----------------------------畅和
			// 课程包id
			categoryIdList: '',
			categoryList: '',
			totalprices: '',
			boughtFlag: '',
			order_id: ''
			// ----------------------------畅和
		}
	},
	methods: {
		//获取购物车商品信息全部勾选状态为false
		getShoppingCartDataFalse: function() {

			this.$post('shopping_cart/search', {
				token: this.$store.state.id,
				offset: '0',
				length: 9999,
				shop_id: this.$store.state.store.id
			}).then(res => {
				this.order = res.data.result.data;
				for (let val of this.order) {
					val.selected = false;
				}
			})
		},
		//获取购物车商品信息全部勾选状态为true
		getShoppingCartDataTrue: function() {
			this.$post('shopping_cart/search', {
				token: this.$store.state.id,
				offset: '0',
				length: 9999,
				shop_id: this.$store.state.store.id
			}).then(res => {
				// console.log(res)
				this.order = res.data.result.data;
				// console.log(this.order)
				for (let val of this.order) {
					val.selected = true;
				}
			})
		},
		//获取购物车商品信息
		updataShoppingCartData: function() {
			this.chooseCount = 0;
			this.$post('shopping_cart/search', {
				token: this.$store.state.id,
				offset: '0',
				length: 9999,
				shop_id: this.$store.state.store.id
			}).then(res => {
				// console.log(res)
				this.order = res.data.result.data;
				// console.log(this.order)
				for (let val of this.order) {
					if (val.selected == 1) {
						val.selected = true;
					} else {
						val.selected = false;
					}
				}
				// 已选门数和总价钱的累加
				for (let val of this.order) {
					if (val.selected) {
						++this.chooseCount;
						this.totalprices += Number.parseFloat(val.category_price);
					}
				}
				// 把已经勾选的true和false导入到数组循环遍历判断是否把全选钩打上
				let arr = [];
				// console.log(this.order[0].selected)
				// console.log(this.order.length)
				for (let n = 0; n < this.order.length; n++) {
					arr[n] = this.order[n].selected;
				}
				// console.log(arr)
				if (arr.includes(false)) {
					this.allChecked = false;
				} else {
					this.allChecked = true;
				}
			})
		},
		// getShoppingCartData: function () {
		//     this.order=[];
		//     this.totalprices=0;
		//     this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: 9999 }).then(res => {           
		//         return res.data.result.data;
		//     }).then(data => {
		//         this.$store.state.shopNum=data.length;
		//         let arr = [];
		//         let me = this;
		//         for (let val of data) {
		//             (function (val) {
		//                 me.$post('products/get', { id: val.product_id }).then(res => {
		//                     let obj = {
		//                         id: val.id,
		//                         product_id: val.product_id,
		//                         selected: val.selected,
		//                         name: res.data.result.name,
		//                         image: res.data.result.image,
		//                         price: res.data.result.price
		//                     };
		//                     //累加总价
		//                     if(val.selected){
		//                         me.totalprices+=Number.parseFloat(res.data.result.price);
		//                     }
		//                     arr.push(obj);
		//                     me.order = arr;
		//                 })
		//             })(val)
		//         }
		//     })
		// },
		//全选按钮
		allChoose: function() {
			this.totalprices = 0;
			this.chooseCount = 0;
			if (this.allChecked == true) {
				for (let val of this.order) {
					this.$post('shopping_cart/edit', {
						token: this.$store.state.id,
						selected: 0,
						id: val.id
					}).then(res => {
						// console.log(res)
					})
					this.getShoppingCartDataFalse();
				}
				// 结算按钮改为灰色
                document.getElementById('closeAnAccount').style.background = "rgb(201, 201, 201)";

			} else {
				for (let val of this.order) {
					this.$post('shopping_cart/edit', {
						token: this.$store.state.id,
						selected: 1,
						id: val.id
					}).then(res => {
						// console.log(res)
					})
					this.getShoppingCartDataTrue();
				}
				// 已选门数和总价钱的累加
				for (let val of this.order) {

					this.totalprices += Number.parseFloat(val.category_price);

					++this.chooseCount;
				}
				// this.totalprices = this.totalprices.toFixed(2);
				// 结算按钮改为橙色
				document.getElementById('closeAnAccount').style.background = "rgb(255,128,0)";
			}

			// if (this.allChecked) {
			//     document.getElementById('closeAnAccount').style.background="rgb(201, 201, 201)";
			//     for (let val of this.order) {
			//         val.selected = false;
			//         this.chooseCount = 0;
			//     }
			//     this.totalprices = 0;
			//     this.selectedOrder = ""
			// } else {
			//     this.totalprices = 0;
			//     document.getElementById('closeAnAccount').style.background="rgb(255,128,0)";
			//     for (let val of this.order) {
			//         val.selected = true;
			//         this.chooseCount = this.order.length;
			//         this.totalprices += Number.parseFloat(val.price);
			//     }
			// }
		},
		//多选框按钮
		choose: function(id, index) {
			this.totalprices = 0;
			this.chooseCount = 0;
			// console.log(index)
			// console.log(this.order[index].selected)
			if (this.order[index].selected == true) {
				this.$post('shopping_cart/edit', {
					token: this.$store.state.id,
					selected: 1,
					id: id
				}).then(res => {
					// console.log(res)
				})
			} else {
				this.$post('shopping_cart/edit', {
					token: this.$store.state.id,
					selected: 0,
					id: id
				}).then(res => {
					// console.log(res)
				})
			}
			// 把已经勾选的true和false导入到数组循环遍历判断是否把全选钩打上
			let arr = [];
			// console.log(this.order[0].selected)
			// console.log(this.order.length)
			for (let n = 0; n < this.order.length; n++) {
				arr[n] = this.order[n].selected;
			}
			// console.log(arr)
			if (arr.includes(false)) {
				this.allChecked = false;
			} else {
				this.allChecked = true;
			}
			// 改变结算按钮的颜色
			if (arr.includes(true)) {
				// 橙色
				document.getElementById('closeAnAccount').style.background = "rgb(255,128,0)";
			} else {
				// 灰色
				document.getElementById('closeAnAccount').style.background = "rgb(201, 201, 201)";
			}
			// 已选门数和总价钱的累加
			for (let val of this.order) {
				if (val.selected) {
					++this.chooseCount;
					// console.log(`累加之前总价：${this.totalprices}  单品价格：${Number.parseFloat(val.product_price)}`)
					this.totalprices += Number.parseFloat(val.category_price);
					// console.log(`累加之后总价：${this.totalprices}`)
					// console.log('================')
				}
			}
			// this.chooseCount = 0;
			// this.totalprices = 0;
			// let select='';
			// for (let val of this.order) {  
			//     if (val.selected) {
			//         this.allChecked = true;
			//     } else {       
			//         this.allChecked = false;
			//         break;
			//     }
			// }
			// for (let val of this.order) {
			//     if (val.selected) { 
			//         ++this.chooseCount;
			//         this.totalprices += Number.parseFloat(val.price);
			//     }
			//     if(val.id===id){
			//         if(val.selected===false){
			//             select=0;
			//         }else if(val.selected===true){
			//             select=1;
			//         }else{
			//             select=val.select;
			//         }
			//     }
			// }
			// if(this.chooseCount!==0){
			//     document.getElementById('closeAnAccount').style.background="rgb(255,128,0)";
			// }else{
			//     document.getElementById('closeAnAccount').style.background="rgb(201, 201, 201)";
			// }
		},

		//删除购物车中的课程包
		deleteCommodity: function(id) {
			this.totalprices = 0;
			this.$post('shopping_cart/delete', {
				token: this.$store.state.id,
				id: id
			}).then(res => {
				this.updataShoppingCartData();
			})
			this.$message({
				message: '已移出购物车',
				type: 'success'
			});

		},
		// 结算按钮事件
		closeAccount: function() {
			// 产品id数组
			let selectedOrder = [];
			let falseArr = [];
			// let shopId = [];
			// 整合已勾选商品的product_id和id到数组
			for (let val of this.order) {
				if (val.selected) {
					selectedOrder.push(val.category_id);
					// shopId.push(val.id);
				} else {
					falseArr.push(false);
				}
			}
			// 如果无勾选让结算按钮无操作
			if (falseArr.length === this.order.length) {
				// let model = document.querySelector('.shoppingRemind');
				// UIkit.modal(model).show();
				return;
			}
			// 跳转到pay支付页面
			this.$router.push({
				path: '/pay',
				query: {
					commodityList: JSON.stringify(selectedOrder)
				}
			})
		},
		// --------------------------------------------------------------郑州畅和-------------------------------------------------------------------------------------------------
		// 结算按钮事件
		closeAccount1: function() {

			let selectList = [];
			let str = ''
			// 产品id数组
			let selectedOrder = [];
			let falseArr = [];
			// let shopId = [];
			// 整合已勾选商品的product_id和id到数组
			for (let val of this.order) {
				if (val.selected) {
					selectedOrder.push(val.category_id);
					selectList.push(val)
					// shopId.push(val.id);
				} else {
					falseArr.push(false);
				}
			}
			console.log(selectList, 'selectList')
			selectList.map(item=>{
				str += '《' + item.category_name + '》'
			})
			this.categoryIdList = selectedOrder
			// 如果无勾选让结算按钮无操作
			if (falseArr.length === this.order.length) {
				// let model = document.querySelector('.shoppingRemind');
				// UIkit.modal(model).show();
				return;
			}
			// 跳转到pay支付页面
			// this.$router.push({
			//     path: '/pay',
			//     query: {
			//         commodityList: JSON.stringify(selectedOrder)
			//     }
			// })
			this.$confirm('是否确认开通' + str + '等课程', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.getGoods()
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
			
		},
		//根据传来的id查找
		getGoods: function() {
			console.log(2)
			for (let id of this.categoryIdList) {
				((id) => {
					this.$post('product_category/get', {
						id: id
					}).then(res => {
						res.data.result.id = id;
						this.categoryList.push(res.data.result);
						this.totalprices += Number.parseFloat(res.data.result.price);
					});
				})(id);
			}
			this.isBought()
		},
		isBought: function() {
			let me = this;
			console.log(3)
			me.$post('orders/paid_order', {
				token: me.$store.state.id,
				offset: 0,
				length: 999
			}).then(res => {
				// list是用户state等于2的订单数组
				let list = res.data.result.data.map(item => item.id);
				// 发送请求，查看是否已经购买过当前的课程包
				me.$post('category_order/search', {
					category_ids: JSON.stringify(me.categoryIdList),
					order_ids: JSON.stringify(list),
					offset: 0,
					length: 999
				}).then(res2 => {

					let list2 = res2.data.result.data;

					if (list2.length === 0) {
						// 用户没有购买过这个课程包
						me.boughtFlag = true;
					} else {
						// 用户购买过该课程包
						me.boughtFlag = false;
					}
					me.payMoney();
				});
			});
		},
		//立即下单
		payMoney: function() {
			console.log(4)
			// 发送请求创建订单
			this.$post('orders/create_order', {
				token: this.$store.state.id,
				category_ids: JSON.stringify(this.categoryIdList),
				pay_type: 6,
				invoice_title: '',
				tax_no: '',
				invoice_type: '',
				invoice_email: '',
				invoice_address: '',
				invoice_open_bank: '',
				shop_id: this.$store.state.store.id
			}).then(res => {
				if (res.data.status === 'success') {

					// 创建订单成功，删除购物车中的对应的数据
					// 发送请求获取当前的购物车中的对应的数据
					this.$post('shopping_cart/search', {
						token: this.$store.state.id,
						category_ids: JSON.stringify(this.categoryIdList),
						shop_id: this.$store.state.store.id,
						offset: 0,
						length: 999
					}).then(res2 => {
						// list是当前用户正在购买的课程包的购物车列表
						let list = res2.data.result.data.map(item => item.id);

						// list的长度大于0，有符合条件的购物车数据(同一个用户同一个课程包)，删除数据
						if (list.length > 0) {
							for (let i of list) {
								this.$post('shopping_cart/delete', {
									token: this.$store.state.id,
									id: i
								}).then(() => {

									// 重新查询购物车
									this.$post('shopping_cart/search', {
										token: this.$store.state.id,
										offset: 0,
										length: 999,
										shop_id: this.$store.state.store.id
									}).then(res => {
										this.$store.state.shopNum = res.data.result.data.length;
									});
								})
							}
						}

					})
					this.order_id = res.data.result
					this.goOrderDetails()
					// 跳转到支付页面
					// this.$router.replace({
					//     path: '/paycenter',
					//     query: {
					//         order_id: res.data.result,
					//         commodityList: JSON.stringify(this.categoryList)
					//     }
					// });

				} else {
					this.$message.error('下单失败，请稍后重试');
				}
			})

		},
		//选择不同支付方式
		goOrderDetails() {
			console.log(5)
			//获取账户余额
			this.$post('users/profile', {
				token: this.$store.state.id
			}).then(res => {
				let balance = 0;
				if (res.data.status === 'success') {
					let balance1 = res.data.result.balance;
					//计算支付后的余额
					balance = (balance1 * 100 - this.totalprices * 100) / 100;
					if (balance < 0) {
						this.$message({
							showClose: true,
							message: '余额不足',
							type: 'error'
						});
					} else {
						//更新账户余额
						this.updataBalance(balance);

						// 向余额日志表中插入数据
						// this.createLog(balance, this.totalprices)
					}
				}
			})
		},
		//更新账户余额
		updataBalance(balance) {
			console.log(6)
			let orderId = this.order_id;
			// console.log(balance);
			this.$post('users/balance_token', {
				balance: balance,
				token: this.$store.state.id,
				total: this.totalprices,
				order_id: orderId
			}).then(res => {
				if (res.data.status === 'success') {
					// 更改订单状态
					this.updataOrder();
				} else {
					this.$message({
						showClose: true,
						message: '支付失败',
						type: 'error'
					});
				}
			})

		},
		// 更改订单状态
		updataOrder() {
			// let date = this.getPayDate()
			// console.log(date)
			let date = new Date(+new Date() + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
			// console.log('当前时间', date)

			this.$post('orders/edit_state', {
				pay_type: 5,
				state: 2,
				id: this.order_id,
				token: this.$store.state.id,
				pay_date: date
			}).then(res => {
				this.getShoppingCartDataFalse()
				// console.log(res.data.status);
				if (res.data.status === 'success') {
					this.$message({
						showClose: true,
						message: '已成功确认，请前往个人中心学习',
						type: 'success'
					});
					// this.toPayBtn = true
					// console.log(this.$route.query.order_id);
					// this.$router.replace({
					// 	path: '/myorderdetails',
					// 	query: {
					// 		order_id: this.$route.query.order_id,
					// 		categoryList: this.$route.query.commodityList
					// 	}
					// });
				} else {
					this.$message({
						showClose: true,
						message: '订单生成失败',
						type: 'error'
					});
				}
			})
		},
		// --------------------------------------------------------------郑州畅和-------------------------------------------------------------------------------------------------
	},
	created: function() {
		// 首次获取全部商品，默认全部勾选为false
		this.getShoppingCartDataFalse();
	},
	mounted: function() {
		document.title = '购物车';
	},
}
